module.exports = __webpack_public_path__ + "static/media/fluor.9b8ebe71.png";